import { useParams } from "react-router-dom";
import Cookies from "js-cookie";

// === USER COMPONENTS ===
import ModelConfiguration from "../Component/Dashboard/Default/TabLots/ModelConfiguration";
import DocsConfiguration from "../Component/Dashboard/Default/TabDocs/DocsConfiguration";

// === ADMIN COMPONENTS ===
import AdmLotsTable from "../Component/Admin/Dashboard/default/AdmTabLots/AdmLotsTable";
import AdmDocsTable from "../Component/Admin/Dashboard/default/AdmTabDoc/AdmDocsTable";

export default function DynamicModelRouter() {
  const { configKey } = useParams();
  const role = Cookies.get("Role");

  if (role === "user") {
    if (configKey && configKey.includes("Docs")) {
      return <DocsConfiguration />;
    }
    return <ModelConfiguration />;
  }

  if (role === "superadmin") {
    if (configKey && configKey.includes("Docs")) {
      return <AdmDocsTable />;
    }
    return <AdmLotsTable />;
  }

  // 🔹 Fallback : rôle inconnu
  return <div>Accès non autorisé.</div>;
}
